import React, { useEffect } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import commonStyles from "../../substrateV2/Substrate.less";
import { trackEventCallback } from "../../../utils/AppInsights";
import { LogComponent, LogElement, LogTarget } from "../../../models/LogModel";
import InsightPortalCostCard from "./InsightPortalCostCard";
import { useInsightId } from "./useInsightId";
import CommonConstants from "../../../models/constants/CommonConstants";
import { PlatformTypeEnum, IInsightUsageBO } from "../../../models/InsightsPlatformModels";
import { InsightBarChart } from "../InsightCard/InsightBarChart";
import RecommendationInsightSidePanel from "./RecommendationInsightSidePanel";
import AnomalyPivotTable from "./AnomalyPivotTable";

export interface IInsightPortalByRecommendationsProps {
    recommendationUsageSummaryData: Record<string, number>;
    recommendationDetailList: IInsightUsageBO[];
    recommendationTotalCost: number;
}

export const InsightPortalByRecommendations: React.FunctionComponent<IInsightPortalByRecommendationsProps> = (props) => {
    const [insightId, setInsightId] = useInsightId();

    const [isInsightsCardOpen, { setTrue: openInsightsCard, setFalse: dismissInsightsCard }] = useBoolean(false);

    const showInsightCards = React.useCallback((insightId: string) => {
        trackEventCallback(
            LogComponent.InsightTable,
            LogElement.InsightExpandSidePanel,
            `Expand Insight Side Panel: ${insightId}`,
            LogTarget.Title
        );
        setInsightId(insightId);
        openInsightsCard();
    }, [setInsightId, openInsightsCard]);

    const handleDismissInsightCards = () => {
        dismissInsightsCard();
        setInsightId("");
    };

    const recommendationCardData = React.useMemo(
        () =>
            Object.entries(props.recommendationUsageSummaryData)
                .map(([key, value], index) => ({
                    name: key || "",
                    y: value || 0,
                    color: CommonConstants.DefaultColors[index],
                }))
                .filter((item) => item.y > 0),
        [props.recommendationUsageSummaryData]
    );

    return (
        <div style={{marginTop:48, marginLeft:48, marginRight:48}}>
            <div className={`${commonStyles.gridWrapper} ${commonStyles.gridColumn2}`}>
                <InsightPortalCostCard data={props.recommendationUsageSummaryData} title="total monthly savings opportunity" highlightColor="#107C10"/>
                <div style={{width:350}}>
                    <InsightBarChart metricValueRecord={props.recommendationUsageSummaryData}/>
                </div>
                { insightId !== "" && <RecommendationInsightSidePanel isPanelOpen={isInsightsCardOpen} onDismiss={function (): void {
                    handleDismissInsightCards();
                } } insightId={insightId}></RecommendationInsightSidePanel>}
            </div>
            <AnomalyPivotTable data={props.recommendationDetailList} totalCost={props.recommendationTotalCost} showInsightCard={showInsightCards} isRecommendationPage={true}/>
        </div>
    );
};